export enum ResultOfExposureEnum {
    NO_DATA,
    OTHER,
    LOSS_OF_FUNCTIONALITY_OF_SYSTEMS,
    SYSTEM_BREACH,
    DATA_LEAK
}
